import moment from "moment-timezone";

import angular from "angular";

function calculateElectionDate(electionYear) {
    if (!Number.isInteger(electionYear)) {
        return undefined;
    }

    var electionMoment = moment({
        year: electionYear,
        month: 10, //November, zero-indexed
        day: 1
    });

    var currentDay = electionMoment.day();

    var dayAdjustFactor = ((currentDay < 2) ? 2 : 9);

    electionMoment.day(dayAdjustFactor);

    return electionMoment;
}

class PriorFederalElectionDateService {
    constructor() {
    }

    getPriorCycleElectionDate(targetMoment) {

        if (!moment.isMoment(targetMoment)) {
            return undefined;
        }

        var targetYear = targetMoment.year();

        if ((targetYear % 2) === 0) {
            var electionInTargetYear = calculateElectionDate(targetYear);


            if (electionInTargetYear.isBefore(targetMoment)) {
                return electionInTargetYear;
            }
            else {
                return calculateElectionDate(targetYear - 2);
            }
        }
        else {
            return calculateElectionDate(targetYear - 1);
        }
    }

    toString() {
        return "Election Date Service";
    }

    getElectionDate(electionYear) {
        return calculateElectionDate(electionYear);
    }
}

PriorFederalElectionDateService.$inject = [];

export default angular
    .module("trackerbase-app.services.election-date-service",[])
    .service("ElectionDateService", PriorFederalElectionDateService)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/services/PriorFederalElectionDateService.js
// module id = pcyp
// module chunks = 1